import { render, staticRenderFns } from "./simples-das.vue?vue&type=template&id=3f372e64&scoped=true&"
import script from "./simples-das.vue?vue&type=script&lang=js&"
export * from "./simples-das.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f372e64",
  null
  
)

export default component.exports